<template>
    <v-card min-width="35vw" align="center" justify="center" light outlined>
        <v-card-title style="background-color: #d2d7e1">
            <v-list-item>
                <v-list-item-title><h2>{{ user.user.firstName }}'s User</h2></v-list-item-title>
                <v-spacer/>
                <v-list-item-action><v-icon class="icon" @click="closeWindow" icon>fa-times</v-icon></v-list-item-action>
            </v-list-item>
        </v-card-title>
        <v-card-text class="pt-3 pb-1">
            <v-container fluid>
                <v-row>
                    <v-col cols="6" xl="4" lg="4" md="4">
                        <h3>Name</h3>
                        <p>{{ user.user.firstName }} {{ user.user.lastName }}</p>
                        <h3 :class="($store.state.desktop)? 'mt-7' : ''">Username</h3>
                        <p>{{ user.user.login }}</p>
                        <h3 :class="($store.state.desktop)? 'mt-7' : ''">Arrived From</h3>
                        <p>{{ formatText(user.arrivedFromChannel) }}</p>
                    </v-col>
                    <v-col cols="6" xl="4" lg="4" md="4">
                        <h3>Email</h3>
                        <p>{{ user.user.email }}</p>
                        <h3 :class="($store.state.desktop)? 'mt-7' : ''">Country</h3>
                        <p>{{ user.country }}</p>
                        <h3 :class="($store.state.desktop)? 'mt-7' : ''">Pro Expiration</h3>
                        <p>{{ user.proExpirationDate.substr(0, 10) }}</p>
                    </v-col>
                    <v-col cols="12" xl="4" lg="4" md="4">
                        <h3>Phone</h3>
                        <p>{{ user.phoneNumber }}</p>
                        <h3 :class="($store.state.desktop)? 'mt-7' : ''">User from</h3>
                        <p>{{ user.convertedFrom.substr(0, 10) }}</p>
                        <h3 :class="($store.state.desktop)? 'mt-7' : ''">Profile Visibility</h3>
                        <p>{{ (user.profileStatus != null)? formatText(user.profileStatus) : 'NA' }}</p>
                    </v-col>
                </v-row>
                <v-row class="d-flex justify-center">
                    <v-btn @click="closeWindow">Close</v-btn>
                </v-row>
            </v-container>
        </v-card-text>
    </v-card>
</template>

<script>
    export default {
        name: "ShowUser",
        props: {
            user: Object,
        },
        mounted() {
        },
        methods: {
            closeWindow() {
                this.$emit('closeWindow');
            },
            formatText(text) {
                let partialText = text.split('_').join(' ');
                return partialText[0] + partialText.slice(1).toLowerCase();
            },
        }
    }
</script>

<style scoped>

</style>
